module.exports = __webpack_public_path__ + "static/media/TightKnitLogoWhite.8aee5eb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/TightKnitLogoWhite.svg
// module id = 315
// module chunks = 0